<template>
  <div class="AtlasWidget">
    <template v-if="isSupported">
      <atlas-params>
        <template v-slot:default="params">
          <atlas-indicator-controls
            class="AtlasWidget-controls"
            :indicator-id="params.indicatorId"
            :categories="categories"
            :links="links"
            :geo-controls="geoControls"
            :breakdown-slug="params.breakdownId"
          />

          <atlas-indicator
            :indicator-id="params.indicatorId"
            :breakdown-id="params.breakdownId"
            :args="params.args"
            :geo-code="params.geoCode"
            :geo-compare-code="params.geoCompareCode"
            :geo-type="params.geoType"
            :geo-persistence="geoPersistence"
            :geo-complexity="params.geoComplexity"
            :display-mode="displayMode"
          />
        </template>
      </atlas-params>

      <atlas-tour />
    </template>

    <atlas-unsupported v-else />
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue';
import { mapState, mapMutations } from 'vuex';

import AtlasUnsupported from './unsupported.vue';
import AtlasTour from './tour.vue';
import AtlasParams from './params.vue';

export default defineComponent({
  name: 'atlas-widget',

  components: {
    AtlasUnsupported,
    AtlasTour,
    AtlasParams,
  },

  props: {
    categories: {
      type: Array,
    },

    links: {
      type: Array,
    },

    indicator: {
      type: String,
    },

    breakdown: {
      type: String,
    },

    /**
     * Controls visibility of geo select and compare controls
     * if allowGeoCompare is enabled for breakdown.
     */
    geoControls: {
      type: Boolean,
      default: true,
    },
    geoPersistence: {
      type: Boolean,
      default: false,
    },

    theme: {
      type: String,
    },

    mode: {
      type: String,
      default: 'app',
    },
  },

  provide() {
    return {
      widgetContext: computed(() => ({})),
    };
  },

  computed: {
    ...mapState('ui', ['isSupported']),

    displayMode() {
      return this.$route.query.mode || this.mode;
    },
  },

  watch: {
    theme: {
      immediate: true,
      handler(theme) {
        this.setTheme({ theme });
      },
    },
  },

  methods: {
    ...mapMutations('display', ['setTheme']),
  },
});
</script>

<style lang="scss">
.AtlasWidget {
  box-sizing: border-box;

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  &-controls {
    @media screen and (min-width: 1100px) {
      margin: 0 15px 40px;
    }
  }

  &-notSupported {
    padding: 200px 30px;
    background-color: #f0f0f0;
    text-align: center;
  }
}
</style>
